/**
 * V70G6B — 엔글 오목 FE 타입.
 *   BE 응답 (publicRoom doc) 과 매칭.
 */

export const BOARD_SIZE = 15;
export const BOARD_LEN = 225;

export type OmokRoomStatus = 'waiting' | 'playing' | 'finished' | 'abandoned';
export type OmokSide = 'black' | 'white';
export type OmokWinner = 'black' | 'white' | 'draw' | null;
// 'overline' = 백돌 6목 이상 승리 (렌주룰상 백만 허용)
// 'timeout' = 한 수 30초 초과 (V70G8D)
export type OmokWinReason = 'five' | 'overline' | 'resign' | 'abandon' | 'timeout' | null;
export type OmokForbidReason = 'double-three' | 'double-four' | 'overline';

export interface OmokPublicPlayer {
  publicPlayerId: string;
  displayName: string;
  orgUnitName: string | null;
}

export interface OmokLastMove {
  x: number;
  y: number;
  by: OmokSide;
  at: unknown; // Firestore Timestamp
}

export interface OmokWinningLineCell {
  x: number;
  y: number;
}

export interface OmokPublicRoom {
  roomId: string;
  roomCode: string;
  status: OmokRoomStatus;
  playerBlack: OmokPublicPlayer | null;
  playerWhite: OmokPublicPlayer | null;
  board: number[]; // 225 cells, 0=empty, 1=black, 2=white
  nextTurn: OmokSide;
  moveCount: number;
  lastMove: OmokLastMove | null;
  winner: OmokWinner;
  winReason: OmokWinReason;
  winningLine: OmokWinningLineCell[] | null;
  endedAt: unknown | null;
  updatedAt: unknown;
  // V70G6E — 서버 waiting→playing 전환 시각. FE 는 (now - playingStartedAt) < 3초 시 연출 phase.
  playingStartedAt: unknown | null;
  // V70G8D — 한 수 제한(ms)과 현재 차례 마감 시각. 판정은 서버, FE 는 표시만.
  turnTimeLimitMs?: number | null;
  turnDeadlineAt?: unknown | null;
}

export interface OmokMoveResultServer {
  moveNo: number;
  nextTurn: OmokSide;
  status: OmokRoomStatus;
  winner: OmokWinner;
  winReason: OmokWinReason;
  winningLine: OmokWinningLineCell[] | null;
  reused?: boolean;
}
